/**
 * Idempotency keys (§4.2).
 *
 * One key per mutation ATTEMPT, reused across retries of that attempt. That is
 * the whole rule, and it is why this lives in the transport rather than in
 * fifty hooks: a key minted per retry deduplicates nothing, and a key reused
 * across genuine submissions silently drops the second one.
 *
 * `crypto.randomUUID` needs a secure context. Every browser we target has it
 * over https and on localhost; the fallback exists so a test environment
 * without it does not fail at import time.
 */
export function newIdempotencyKey() {
    const source = typeof crypto === 'undefined' ? undefined : crypto;
    if (source?.randomUUID)
        return source.randomUUID();
    if (!source)
        throw new Error('No crypto source for an Idempotency-Key');
    // RFC 4122 v4 shape, from getRandomValues. Not used in any browser we ship to.
    const bytes = new Uint8Array(16);
    source.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
//# sourceMappingURL=idempotency.js.map